import React from "react";

const ContactDetails = () => {
  return (

<>
 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title">Contact Us</h2>
        </div>
      </div>
    </section>




    <section className="contact-details-section pt_120 pb_90">
      <div className="container">
        <div className="section-title centred mb_60">
          {/* <span className="sub-title">Contact Details</span> */}
          <h2 className="title">Contact Information</h2>
        </div>

        <div className="row">
         
          {/* Phone */}
          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <div className="contact-info-item centred">
              <div className="contact-info-icon">
                <i className="fa-solid fa-phone"></i>
              </div>
              <h4 className="contact-info-title text-center">Phone Number</h4>
              <div className="contact-info-text text-center">
                <a href="tel:+918767592195">+91 8767592195</a>
                <a href="tel:+919172145909">+91 9172145909</a>
              </div>
            </div>
          </div>


          {/* Email */}
          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <div className="contact-info-item centred">
              <div className="contact-info-icon">
                <i className="fa-solid fa-envelope"></i>
              </div>
              <h4 className="contact-info-title text-center">Email Address</h4>
              <div className="contact-info-text text-center">
                <a href="mailto:booking@lotuscab.com">booking@lotuscab.com</a>
                <br />
              </div>
            </div>
          </div>



 {/* Location */}
          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <div className="contact-info-item centred">
              <div className="contact-info-icon">
                <i className="fa-solid fa-location-dot"></i>
              </div>
              <h4 className="contact-info-title text-center">Our Location</h4>
              <div className="contact-info-text text-center">
                <h5 className="fw-bold">Lotus Cab</h5>
                <p>Mauli Krupa building,
Sant Tukaram Nagar Gali No.1,
Navi sangvi MK chauk -411027</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>


 <section className="google-map-section">
      <div className="container">
     
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1383730.8518505222!2d72.31812776812657!3d19.240470748091894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8c3cb5cdd86070e5%3A0x6991a7b95cc1d68a!2sLotus%20Cab!5e1!3m2!1sen!2sin!4v1771048829843!5m2!1sen!2sin" width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>





        
      </div>
    </section>

</>
  );
};

export default ContactDetails;
